module.exports = __webpack_public_path__ + "img/icon7.be541867.svg";